export enum RecipientType {
    Primary = 'primary',
    Secondary = 'secondary',
}
